import { Component } from '@angular/core';
import { Tabla } from '../../tabla';

@Component({
    template: `
    <app-tabla [tabla]=tabla></app-tabla>
` })
export class RecordComponent {

    tabla: Tabla = {
        titulo: 'Records',
        endPoint: '/rest-api/public/record',
        editable: false,
        columnas: [
            {
                name: 'Categoria',
                prop: 'categoriaDeporte.categoria',
                cell: 'nombre',
                editable: false,
                resizeable: true,
                sortable: true,
                width: 120
            },
            {
                name: 'Deporte',
                prop: 'categoriaDeporte.deporte',
                cell: 'nombre',
                editable: false,
                resizeable: true,
                sortable: true,
                width: 160
            },
            {
                name: 'Sexo',
                prop: 'resultado.alumno.sexo',
                cell: 'nombre',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 70
            },
            {
                name: 'Alumno',
                prop: 'resultado.alumno',
                cell: 'nombre',
                editable: false,
                resizeable: true,
                sortable: true,
                width: 300
            },
            {
                name: 'Año',
                prop: 'anio',
                editable: false,
                resizeable: true,
                sortable: true,
                width: 75
            },
            {
                name: 'Valor',
                prop: 'resultado',
                cell: 'valor',
                editable: false,
                resizeable: true,
                sortable: true,
                width: 100
            },
            {
                name: 'Casa',
                prop: 'resultado.alumno.casa',
                cell: 'nombre',
                editable: false,
                resizeable: true,
                sortable: true,
                casa: true,
                width: 100
            }
        ]
    };

}
